import React from "react";
import ReactDatePicker from "react-datepicker";
import ReactSelect from "react-select";

const AttributeReturnObj = ({
  attributes = [],
  editData = {},
  attributeHandlerChanges,
}) => {
  if (!Array.isArray(attributes)) return null; // Ensure input is an array
  try {
    return (
      <>
        {attributes.map((obj, index) => {
          if (!obj || !obj.attribute_type) {
            return (
              <div key={index}>
                <span>Invalid input object</span>
              </div>
            );
          }

          // Render input fields based on attribute_type
          if (obj.attribute_type === "text") {
            return (
              <div className="form-group">
                <label>{obj?.headerName}</label>
                {obj?.is_required && <sup className="form-mandatory">*</sup>}
                <input
                  key={index}
                  type="text"
                  name={obj.name}
                  placeholder={obj.placeholder || ""}
                  defaultValue={obj.value || ""}
                  value={editData?.newValue || editData?.[obj?.field]}
                  className="form-control"
                  onChange={(evt) =>
                    attributeHandlerChanges(
                      evt,
                      obj?.field,
                      obj?.attribute_type
                    )
                  }
                />
              </div>
            );
          }
          if (obj.attribute_type === "number") {
            return (
              <input
                key={index}
                type="number"
                name={obj.name}
                placeholder={obj.placeholder || ""}
                defaultValue={obj.value || ""}
              />
            );
          }
          if (obj.attribute_type === "checkbox") {
            return (
              <input
                key={index}
                type="checkbox"
                name={obj.name}
                defaultChecked={!!obj.value}
              />
            );
          }
          if (obj.attribute_type === "radio") {
            return (
              <input
                key={index}
                type="radio"
                name={obj.name}
                value={obj.value || ""}
                defaultChecked={!!obj.checked}
              />
            );
          }
          if (obj.attribute_type === "password") {
            return (
              <input
                key={index}
                type="password"
                name={obj.name}
                placeholder={obj.placeholder || ""}
                defaultValue={obj.value || ""}
              />
            );
          }
          if (
            obj.attribute_type === "date" ||
            obj.attribute_type === "start_date" ||
            obj.attribute_type === "end_date" ||
            obj.attribute_type === "qa_start_date" ||
            obj.attribute_type === "go_live_date"
          ) {
            return (
              <div className="form-group">
                <label>{obj?.headerName}</label>
                {obj?.is_required && <sup className="form-mandatory">*</sup>}
                <ReactDatePicker
                  className="rasta-stripes"
                  selected={
                    editData?.newValue || editData?.[obj?.field]
                      ? new Date(editData?.newValue || editData?.[obj?.field])
                      : ""
                  }
                  dateFormat={"dd-MM-yyyy"}
                  onChange={(evt) =>
                    attributeHandlerChanges(
                      evt,
                      obj?.field,
                      obj?.attribute_type
                    )
                  }
                />
              </div>
            );
          }
          if (obj.attribute_type === "api") {
            let { options } = attributes?.[0];
            if (options) {
              options = options.map((ite) => ({
                label: ite.value,
                value: ite.id,
              }));
            }
            let vall;

            if (editData[obj.field]?.value) {
              vall = options.filter(
                (it) => it.value == editData[obj.field]?.value
              );
            } else {
              vall = options.filter((it) => it.value == editData?.newValue);
            }
            return (
              <div className="form-group">
                <label>{obj?.headerName}</label>
                {obj?.is_required && <sup className="form-mandatory">*</sup>}
                <ReactSelect
                  options={options}
                  value={vall || []}
                  onChange={(evt) =>
                    attributeHandlerChanges(
                      evt,
                      obj?.field,
                      obj?.attribute_type
                    )
                  }
                />
              </div>
            );
          }
          if (obj.attribute_type === "category") {
            let { options } = attributes?.[0];
            if (options) {
              options = options.map((ite) => ({
                label: ite.name,
                value: ite._id,
              }));
            }
            let vall;

            if (editData[obj.field]?.value) {
              vall = options.filter(
                (it) => it.value == editData[obj.field]?.value
              );
            } else {
              vall = options.filter((it) => it.value == editData?.newValue);
            }

            console.log(
              options,
              editData[obj.field]?.value,
              editData?.newValue,
              vall,
              editData,
              2243543543445
            );

            return (
              <div className="form-group">
                <label>{obj?.headerName}</label>
                {obj?.is_required && <sup className="form-mandatory">*</sup>}
                <ReactSelect
                  options={options}
                  value={vall || []}
                  onChange={(evt) =>
                    attributeHandlerChanges(
                      evt,
                      obj?.field,
                      obj?.attribute_type
                    )
                  }
                />
              </div>
            );
          }
          if (obj.attribute_type === "priority") {
            let { options } = attributes?.[0];
            if (options) {
              options = options.map((ite) => ({
                label: ite.option_name,
                value: ite._id,
              }));
            }
            let vall;

            if (editData[obj.field]?.value) {
              vall = options.filter(
                (it) => it.value == editData[obj.field]?.value
              );
            } else {
              vall = options.filter((it) => it.value == editData?.newValue);
            }

            return (
              <div className="form-group">
                <label>{obj?.headerName}</label>
                {obj?.is_required && <sup className="form-mandatory">*</sup>}

                <ReactSelect
                  options={options}
                  value={vall || []}
                  onChange={(evt) =>
                    attributeHandlerChanges(
                      evt,
                      obj?.field,
                      obj?.attribute_type
                    )
                  }
                />
              </div>
            );
          }

          return (
            <input
              key={index}
              type="text"
              name={obj.name}
              placeholder="Default input"
              defaultValue={obj.value || ""}
            />
          );
        })}
      </>
    );
  } catch (err) {}
};

export default AttributeReturnObj;
